import { css, keyframes, SerializedStyles } from '@emotion/react';

import colors from '../../../theme/colors';

const slideIn = keyframes`
  from {
    transform: translateY(-50px);
  }
  to {
    transform: translateY(0);
  }
`;

const staticShake = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.01);
  }
  100% {
    transform: scale(1);
  }
`;

export const rootSx = {
  overflowX: 'hidden' as const,
  overflowY: 'auto' as const,
  outline: 0
};

export const dialogBaseCss = css`
  position: relative;
  width: auto;
  margin: 1.75rem auto;
  pointer-events: none;
  outline: 0;

  &[data-shake='true'] {
    animation: ${staticShake} 0.3s ease-in-out;
  }
`;

export const sizeCss: Record<string, SerializedStyles> = {
  sm: css`
    max-width: 300px;
  `,
  md: css`
    max-width: 500px;
  `,
  lg: css`
    max-width: 800px;
  `,
  xl: css`
    max-width: 1140px;
  `
};

export const contentBaseCss = css`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  animation: ${slideIn} 0.3s ease-out;
  background-color: ${colors.white};
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
`;

export const headerBaseCss = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid ${colors.neutral200};
`;

export const titleCss = css`
  margin-bottom: 0;
  line-height: 1.5;
`;

export const closeButtonCss = css`
  padding: 1rem;
  margin: -1rem -1rem -1rem auto;
  background: transparent;
  border: 0;
  cursor: pointer;
  outline: none;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: ${colors.neutral400};
  text-shadow: 0 1px 0 ${colors.white};
  opacity: 0.5;
  transition: color 0.3s;

  &:hover {
    color: inherit;
    opacity: 0.75;
  }
`;

export const bodyBaseCss = css`
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
`;

export const footerBaseCss = css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid ${colors.neutral200};

  > * {
    margin: 0.25rem;
  }
`;
